import { EMPTY_STRING } from '../../../../constants/common'

export const REQUEST_PROFILE_TAB_ACTIVITIES_ADD_PHASE_MODAL_QA_NAME =
  'requestProfileTabActivitiesAddPhase'

export const REQUEST_PROFILE_TAB_ACTIVITIES_ADD_PHASE_MODAL_FIELD_NAME_NAME =
  'name'

export const REQUEST_PROFILE_TAB_ACTIVITIES_ADD_PHASE_MODAL_FIELD_QA_NAME =
  'requestProfileTabActivitiesAddPhaseName'

export const REQUEST_PROFILE_TAB_ACTIVITIES_ADD_PHASE_MODAL_NAME_MAX_LENGTH = 128

export const REQUEST_PROFILE_TAB_ACTIVITIES_ADD_PHASE_MODAL_INITIAL_VALUES = {
  [REQUEST_PROFILE_TAB_ACTIVITIES_ADD_PHASE_MODAL_FIELD_NAME_NAME]:
    EMPTY_STRING,
}
